var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.recording)?_c('v-btn',{attrs:{"fab":"","large":"","color":"accent"},on:{"click":_vm.startRecording}},[_c('v-icon',[_vm._v("mdi-microphone")])],1):_c('v-btn',{attrs:{"fab":"","large":"","color":"error"},on:{"click":_vm.stopRecording}},[_c('v-icon',[_vm._v("mdi-stop")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }